import * as React from 'react';
import Divider from '@app/react-common/components/divider/Divider';
import { BulkEditModalLayout } from './BulkEditModalLayout';
import { SelectedMethodInfo } from '../BulkEditModal';

export interface ConflictGroup<T extends string = string> {
  key: T;
  label: string;
  methods: SelectedMethodInfo[];
}

interface ConflictResolutionViewProps<T extends string = string> {
  title: string;
  infoMessage: string;
  groups: ConflictGroup<T>[];
  onSelect: (key: T) => void;
  onBack: () => void;
  onClose: () => void;
  minMethodsRequired?: number;
}

export const ConflictResolutionView = <T extends string = string>({
  title,
  infoMessage,
  groups,
  onSelect,
  onBack,
  onClose,
  minMethodsRequired = 2,
}: ConflictResolutionViewProps<T>) => {
  return (
    <BulkEditModalLayout title={title} onClose={onClose} onBack={onBack}>
      <Divider />
      <div className="bulk-edit-modal__alert bulk-edit-modal__alert--info bulk-edit-modal__alert--no-border">
        <i className="icon icon-more_information" />
        <span>{infoMessage}</span>
      </div>
      <div className="bulk-edit-modal__conflict-list">
        {groups
          .filter((group) => group.methods.length > 0)
          .map((group) => {
            const isDisabled = group.methods.length < minMethodsRequired;
            return (
              <div key={group.key} className="bulk-edit-modal__conflict-group">
                <div className="bulk-edit-modal__conflict-group__header">
                  <span>{group.label}</span>
                  <button
                    className={`bulk-edit-modal__conflict-group__header__select${isDisabled ? ' bulk-edit-modal__conflict-group__header__select--disabled' : ''}`}
                    disabled={isDisabled}
                    onClick={() => !isDisabled && onSelect(group.key)}>
                    Select
                  </button>
                </div>
                {isDisabled && (
                  <div className="bulk-edit-modal__conflict-group__warning">
                    <i className="icon icon-warning" />
                    <span>Requires at least {minMethodsRequired} methods</span>
                  </div>
                )}
                {group.methods.map((method) => (
                  <div key={method.id} className="bulk-edit-modal__conflict-group__item">
                    <span className="bulk-edit-modal__conflict-group__item__name">{method.name || '(No name)'}</span>
                    <span className="bulk-edit-modal__conflict-group__item__group">{method.groupName}</span>
                  </div>
                ))}
              </div>
            );
          })}
      </div>
    </BulkEditModalLayout>
  );
};
